<template>
    <v-container class="fill-height">
        <v-row align="center" justify="center">
            <v-col cols="12" class="text-center">
                <img :src="assets.campfire" style="height: 60vh;">
            </v-col>
            <v-col cols="12" class="text-center">
                Serviço em manutenção
            </v-col>
            <v-col cols="12" class="text-center">
                <v-btn @click="$router.push(returnUrl)">
                    Tentar Novamente
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import assets from "../assets/assets";
export default {
    activated() {
        const vm = this;

        vm.returnUrl = decodeURIComponent(vm.$route?.query?.returnUrl) || '/';
    },
    data() {
        return {
            returnUrl: '/',
            assets: assets,
        };
    }
};
</script>